import type { PdfBindingIssue } from '../../shared/pdfBindingValidation';
import type { PdfEngineIssue } from '../../shared/pdf/errors';
import type { PdfDocumentDefinition } from '../../shared/types';

/** One wording for an issue wherever it appears: the form card, Needs attention and the example preview. A field is
 * named by its number, as on its tab; a question by its current wording. */
export function pdfIssueText(document: PdfDocumentDefinition, issue: PdfBindingIssue | PdfEngineIssue): string {
  const placement = issue.placementId && document.placements.find(p => p.id === issue.placementId);
  const question = 'questionId' in issue && issue.questionId ? document.questions.find(q => q.id === issue.questionId) : undefined;
  const name = placement ? `Field ${document.placements.indexOf(placement) + 1}` : question ? question.label.trim() || 'Untitled question for this form' : '';
  return name && !issue.message.startsWith(name) ? `${name}: ${issue.message}` : issue.message;
}
